import { Internet } from './internet';

export class Isp {
  name: string;
  internet: Internet[];
  constructor() {
    this.name = '';
    this.internet = [];
  }

}



// WEBPACK FOOTER //
// ./src/models/isp.ts